/* eslint-disable no-param-reassign */
import produce from 'immer';
import { DISPATCH_STATE_CHANGE, DISPATCHES_COLLECTED } from 'src/actions/dispatchStatusActions';
import find from 'lodash/find';

const initialState = {
  dispatchStatuses: []
};

const dispatchStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case DISPATCHES_COLLECTED: {
      const { dispatchStatuses } = action.payload;

      return produce(state, (draft) => {
        draft.dispatchStatuses = dispatchStatuses;
      });
    }

    case DISPATCH_STATE_CHANGE: {
      const { dispatch } = action.payload;

      return produce(state, (draft) => {
        const dispatchEntry = find(draft.dispatchStatuses, { dispatchId: parseInt(dispatch.dispatchId) });
        if (dispatchEntry) {
          dispatchEntry.statusId = dispatch.statusId;
          dispatchEntry.stateId = dispatch.stateId;
          dispatchEntry.state = dispatch.state;
          dispatchEntry.status = dispatch.status;
        } else {
          draft.dispatchStatuses.push({
            ...dispatch,
            dispatchId: parseInt(dispatch.dispatchId)
          });
        }
      });
    }

    default: {
      return state;
    }
  }
};

export default dispatchStatusReducer;
